import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TransferListProductTableRow from './TransferListProductTableRow';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableBody
} from 'material-ui';

/**
 * A Class to render a table of Transferred Products
 *
 */
class TransferListProductsTable extends Component {

    renderProductRows = (list, searchTerm, type) => {
        return (
            list.map((item, index) => (
                <TransferListProductTableRow
                    key={`${item.id}-${index}`}
                    type={type}
                    data={item}
                    searchTerm={searchTerm}
                />
            ))
        );
    };

    render() {
        const {
            list,
            searchTerm,
            type
        } = this.props;

        const styles = {
            bg: {backgroundColor: '#f6f6f6'},
            row: {height: '35px',},
            column: {height: '35px'},
            columnFirst: {paddingLeft: '36px'},
            columnRight: {height: '35px', textAlign: 'right'},
        };

        return (
            <div>
                <Table selectable={false} multiSelectable={false} style={styles.bg}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow style={styles.row}>
                            <TableHeaderColumn
                                style={{...styles.column, ...styles.columnFirst}}>Barcode</TableHeaderColumn>
                            <TableHeaderColumn style={styles.column}>Product</TableHeaderColumn>
                            <TableHeaderColumn style={styles.columnRight}>Qty</TableHeaderColumn>
                            <TableHeaderColumn style={styles.columnRight}>Unit Qty</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false} style={styles.bg}>
                        {[...this.renderProductRows(list, searchTerm, type)]}
                    </TableBody>
                </Table>
            </div>
        )
    }
}

TransferListProductsTable.propTypes = {
    addField: PropTypes.bool,
    list: PropTypes.array,
    searchTerm: PropTypes.string,
    type: PropTypes.string
};

TransferListProductsTable.defaultProps = {
    addField: true,
    list: [],
    searchTerm: '',
    type: 'any'
};

export default TransferListProductsTable;


// WEBPACK FOOTER //
// ./src/Fuse/components/TransferListProductsTable.js